import styled, { css } from "styled-components";

const TRANSITION_SEC = 0.4;
export const SelectedButton = styled.button`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  font-size: var(--hv-fontsize-body-sm);
  line-height: var(--hv-lineheight-body-sm);
  color: var(--hv-text-normal-secondary);
  border: 1px solid var(--hv-border-default);
  border-radius: 4px;
  transition: border-radius ${TRANSITION_SEC * 1.2}s ease-in-out;

  position: relative;
  display: flex;
  align-items: center;
  padding: 0px 12px 0 8px;
  gap: 8px;

  > span {
    text-align: left;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 172px;
  }

  svg:last-child {
    float: right;
  }

  &:hover {
    background-color: var(--hv-interaction-hover) !important;
  }

  &:active {
    background-color: var(--hv-interaction-press);
  }
`;

export const AccordionList = styled.ul`
  width: 100%;
  height: 0px;
  overflow-y: hidden;
  border: 1px solid var(--hv-border-default);
  border-top: none;
  border-bottom: none;

  transition: height ${TRANSITION_SEC}s ease-in-out;
`;

export const AccordionListItem = styled.li`
  cursor: pointer;
  height: 28px;
  width: 100%;
  color: var(--hv-text-normal-secondary);
  display: flex;
  align-items: center;
  padding-left: 7px;
  font-size: 14px;

  span {
    line-height: 26px;
    max-width: 195px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
  }

  svg.more-icon {
    visibility: none;
  }

  &:hover {
    background-color: var(--hv-interaction-hover) !important;

    svg.more-icon {
      visibility: visible;
    }
  }

  &.selected {
    box-shadow: 2px 0px 0px 0px var(--hv-interaction-select-orange) inset;
    background-color: var(--hv-interaction-press);
  }
`;
export const Container = styled.div<{ isShow: boolean }>`
  position: relative;
  height: auto;

  ${({ isShow }) =>
    isShow &&
    css`
      ${SelectedButton} {
        border-radius: 4px 4px 0 0;

        svg.accordion-arrow-icon {
          transform: rotate(180deg);
        }
      }

      ${AccordionList} {
        height: 100px;
        border-radius: 0 0 4px 4px;
        border-bottom: 1px solid var(--hv-border-default);
      }
    `}
`;

export const DropDownList = styled.ul`
  position: absolute;
  top: 40px;
  right: -84px;

  background-color: var(--surface-popup);
  box-shadow: 0px 2px 2px 0px #0000001a;
  border: 1px solid var(--border-default);
  border-radius: 4px;
  z-index: 1;

  > li {
    color: var(--text-primary);
    height: 32px;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;

    :hover {
      background-color: var(--tree-item-hover);
    }
  }
`;
export const TooltipWrapper = styled.div`
  visibility: hidden;
  display: inline-block;
  &:hover {
    visibility: visible;
  }
`;
